import React from "react";
import DocumentDetailBox from "./documentDetailBox";
import "./admissionDocuments.scss";

const AdmissionDocuments = ({ ADMISSIONDOCUMENT, extraCard }) => {
  let documents = ADMISSIONDOCUMENT;
  const hasDocuments = documents && documents.length > 0;
  return (
    <div className="update-document-box">
      <div className="heading">
        Admission Document {/* <MapDocumentModal/> */}
      </div>
      <hr className="line" />
      <div className="sub-container">
        {hasDocuments ? (
          documents.map((document, idx) => {
            return (
              <DocumentDetailBox
                key={idx}
                docDetails={document}
                siblingDocuments={documents}
              />
            );
          })
        ) : !extraCard ? (
          <div className="sub-heading"> No document mapped</div>
        ) : null}
        {extraCard}
      </div>
    </div>
  );
};

export default AdmissionDocuments;
